// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9":"23aee61ca2bb5db8","8747":"01905d89db1a1c4e"}[chunkId] + ".css";
};